import { DiscoveryApi } from '@backstage/core-plugin-api';

/**
 * A DiscoveryApi implementation that returns relative `/api/<pluginId>` URLs.
 * Used in frontendOnly mode so all Backstage plugin calls go through the
 * webpack-dev-server proxy defined in packages/app/package.json.
 */
export class ProxyDiscoveryApi implements DiscoveryApi {
  async getBaseUrl(pluginId: string): Promise<string> {
    return `/api/${pluginId}`;
  }
}
